<template>
  <div>
   <div class="d-flex" :class="{'focus' : focus > -1, 'dark' : dark}">
      <template v-for="(value,i) in size">
        <v-text-field dense hide-details  :key="i" v-model="text[i]"  
        @focus="focusMe(i,$event)" :dark="dark" 
        outlined flat :placeholder="mask[i]" v-bind="$attrs"
        :hide-spin-buttons="true" solo
        :ref="'input' + i" 
        :type="mask[i] == '*' ? 'number': 'text'" style="width:auto2" 
        class="mr-1 text-uppercase font-weight-normal single-number"
        :class="{'has-focus' : i==focus}"
        :autofocus="autofocus && i==focus"
        :darks="mask[i] == '#' ? true: false"
        :disabled="length<i"
        @keyup="checkField(i,$event)" :maxlength="1" :id="`input${i}`" :background-color="mask[i] == '#' ?  color : color"
        @blur="blur(i)">
    </v-text-field>
    <div v-if="deviders && deviders[i]" :key="i + 100" class="text-h4 mx-1 grey--text fnt-weight-light">{{deviders[i]}}
    </div>
      </template>
    </div>
     <v-progress-linear
      v-if="loading"
      indeterminate
      
    ></v-progress-linear>
  </div>
</template>
<script>
export default {
   props: {
    value: {
      type: String,
      default: function () {
        return ''
      },
    },
    color: {
      type: String,
      default: function () {
        return ''
      },
    },
    size: {
      type: Number,
      default: function () {
        return 10
      },
    },
    rules: {
      type: Array,
      default: function () {
        return []
      },
    },
    mask: {
      type: Array,
      default: function () {
        return ['*','*','*','*','*','*','*','*','*','*']
      },
    },
    deviders: {
      type: Array,
      default: function () {
        return null
      },
    },
    dark: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    loading: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    autofocus: {
      type: Boolean,
      default: function () {
        return false
      },
    },
   },
  data: () => ({
      valid: false,
     show:false,
     message: [],
     focus: 0,
     kk:''
  }),
  computed: {
  focusssss(){
    if(this.value) return  this.value.length
    return 0
  },
   text:{
       get(){
        if (!this.value) return new Array(this.size + 1)
        return this.value.split("")
       },
       set(value){
           this.$emit('input',value.join("").replace(' ',''))
       }
   },
   list(){
       return this.orderlist.filter(ol=>ol.host._id==this.host._id) || []
   },
   length(){
     return (this.value+'').length
   },
  },
  mounted () {
    if(this.value) return  this.focus = this.value.length 
     //console.log('mounted2', this.autofocus)
    if (this.autofocus) setTimeout(this.setFocus,500)
  },
watch: {
    isValid(value){
      if (value) this.$nextTick(()=>this.$emit('finish',this.text.join("").toUpperCase()))
    },
    value(value){
      
      if (value && this.isValid(this.value)) this.$nextTick(()=>this.$emit('finish',this.text.join("").toUpperCase()))
    }
},
methods: {
      blur(index){
        this.focus = -1
        if (index == this.size-1 && this.isValid(this.value)) this.$emit('finish',this.value)
      },
      focusMe(index,event){
          this.focus = index
          event.target.select()
      },
      setFocus(index){
        if (!index) index = this.focus
        if (this.length==5 && index==0) return false
        setTimeout(()=>{
          let inp = document.getElementById('input' + index);
          if (inp) {
              inp.focus()
              inp.select()
          }
        },1)
      },
      isValid(value){
        if (!value) return this.valid = false
        this.message = []
        value = value.toUpperCase()
        this.rules.map(rule=>{
            if (rule(value)!=true) {
                this.message.push(rule(value))
            }
        })
        this.valid = this.message.length == 0 && value.length == this.size
        return this.valid
      },
     checkField(index,event){
        var keycode =  event.keyCode ? event.keyCode : event.which;
        var back = (event.code == 'ArrowLeft'
          || keycode == 8
          || event.code == 'Backspace')
         
         if (!event.target.value && !back) return false
         if (event.target.value.length> 1) event.target.value = event.target.value.substring(0,1)
         if (typeof event.target.value =='string' ) event.target.value = event.target.value.toUpperCase()
         if (back) {
           if (index>0) this.setFocus(index-1)
           this.text[index-1] = null
         }else{
            this.setFocus(index+1)
         }
         /*let inp = document.getElementById('input' + rel);
         if (inp) {
             inp.focus()
             inp.select()
         }*/
         this.isValid(this.text.join(""))
        // console.log(this.isValid(this.text.join("")),this.valid,this.text,this.text.join(""))
         this.text = this.text
         //this.$nextTick(()=>{
           
           //this.setFocus()
         //})
     }
  }
}


</script>
<style>
/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px white inset !important;
}
.single-number {
  border:1px solid rgba(0,0,0,0.3);
  /*display:inline-block;*/
}
div.d-flex.focus .single-number{
  border:1px solid rgba(0,0,0,0.6)!important;
}
div.d-flex.focus.dark .single-number{
  border:1px solid rgba(255,255,255,0.6)!important;
}
.single-number.has-focus{
  border:1px solid rgba(0,0,0,0.8)!important;
}
.dark .single-number {
  border:1px solid rgba(255,255,255,0.3);
  /*display:inline-block;*/
}
.dark .single-number.has-focus{
  border:1px solid rgba(255,255,255,0.8)!important;
}
.single-number .v-input__slot{
  padding: 0 2px!important;
  
}
.single-number input{
  text-align: center;
  text-transform: uppercase;
  
}
.single-number fieldset {
  display:none;
}
.v-text-field input[type='number'] {
    -moz-appearance:textfield;
}
.v-text-field input::-webkit-outer-spin-button,
.v-text-field input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
.text-uppercase input {
  text-transform: uppercase !important;
}
</style>
